import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationUnitsService } from '../api/organization-units.service';
import { ORGANIZATION_UNITS_KEYS } from './queryKeys';

export function useMemberSummary(memberId: string, enabled: boolean) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: ORGANIZATION_UNITS_KEYS.memberSummary(activeOrganizationId ?? '', memberId),
    queryFn: ({ signal }) => organizationUnitsService.getMemberSummary(memberId, signal),
    staleTime: 30_000,
    enabled: enabled && !!activeOrganizationId && !!memberId,
  });
}
